import { apiSlice } from "../app/api/apiSlice";

export const userReportsSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getSalesByEmployee: builder.query({
            query: ({user_id,pagination,start_date,end_date,employee_id}) => `user/sales-by-employee/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByEmployee']
        }),
        
        getSalesByEmployeeByDateRange: builder.mutation({
            query: ({user_id,pagination,start_date,end_date,employee_id}) => `user/sales-by-employee/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByEmployee']
        }),

        getSalesByEmployeePageChange: builder.mutation({
            query: ({user_id,pagination,start_date,end_date,employee_id,page}) => `user/sales-by-employee/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByEmployee']
        }),

        getSalesByCateroty: builder.query({
            query: ({user_id,pagination,start_date,end_date}) => `user/sales-by-category/${user_id}/${pagination}/${start_date}/${end_date}}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByCategory']
        }),

        getSalesByCaterotyByDateRange: builder.mutation({
            query: ({user_id,pagination,start_date,end_date}) => `user/sales-by-category/${user_id}/${pagination}/${start_date}/${end_date}}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByCategory']
        }),

        getSalesByCaterotyPageChange: builder.mutation({
            query: ({user_id,pagination,start_date,end_date,page}) => `user/sales-by-category/${user_id}/${pagination}/${start_date}/${end_date}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByCategory']
        }),

        getSalesByPaymentType: builder.query({
            query: ({user_id,pagination,start_date,end_date,employee_id}) => `user/sales-by-payment-type/${user_id}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByPaymentType']
        }),

        getSalesByPaymentTypeByDateRange: builder.mutation({
            query: ({user_id,start_date,end_date,employee_id}) => `user/sales-by-payment-type/${user_id}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByPaymentType']
        }),

        getSalesByTaxName: builder.query({
            query: ({user_id,start_date,end_date,employee_id}) => `user/sales-by-tax-name/${user_id}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByTaxName']
        }),

        getSalesByTaxNameByDateRange: builder.mutation({
            query: ({user_id,start_date,end_date,employee_id}) => `user/sales-by-tax-name/${user_id}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByTaxName']
        }),

        getSalesByDiscountName: builder.query({
            query: ({user_id,start_date,end_date,employee_id}) => `user/sales-by-discounts-name/${user_id}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByDiscountName']
        }),

        getSalesByDiscountNameByDateRange: builder.mutation({
            query: ({user_id,start_date,end_date,employee_id}) => `user/sales-by-discounts-name/${user_id}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByDiscountName']
        }),

        getSalesByRoute: builder.query({
            query: ({user_id,pagination,start_date,end_date,employee_id}) => `user/sales-by-route/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByRoute']
        }),

        getSalesByRouteWithDateRange: builder.mutation({
            query: ({user_id,pagination,start_date,end_date,employee_id}) => `user/sales-by-route/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByRoute']
        }),

        getSalesByRoutePageChange: builder.mutation({
            query: ({user_id,pagination,start_date,end_date,employee_id,page}) => `user/sales-by-route/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesByEmployee']
        }),

        getSalesSummary: builder.query({
            query: ({user_id,pagination,start_date,end_date,employee_id}) => `user/sales-summary/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesSummary']
        }),

        getSalesSummaryWithDateRange: builder.mutation({
            query: ({user_id,pagination,start_date,end_date,employee_id}) => `user/sales-summary/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesSummary']
        }),

        getSalesSummaryPageChange: builder.mutation({
            query: ({user_id,pagination,start_date,end_date,employee_id,page}) => `user/sales-summary/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['SalesSummary']
        }),
    })
})

export const {
    useGetSalesByEmployeeQuery,
    useGetSalesByEmployeeByDateRangeMutation,
    useGetSalesByEmployeePageChangeMutation,
    useGetSalesByCaterotyQuery,
    useGetSalesByCaterotyByDateRangeMutation,
    useGetSalesByCaterotyPageChangeMutation,
    useGetSalesByPaymentTypeQuery,
    useGetSalesByPaymentTypeByDateRangeMutation,
    useGetSalesByTaxNameQuery,
    useGetSalesByTaxNameByDateRangeMutation,
    useGetSalesByDiscountNameQuery,
    useGetSalesByDiscountNameByDateRangeMutation,
    useGetSalesByRouteQuery,
    useGetSalesByRouteWithDateRangeMutation,
    useGetSalesByRoutePageChangeMutation,
    useGetSalesSummaryQuery,
    useGetSalesSummaryWithDateRangeMutation,
    useGetSalesSummaryPageChangeMutation
} = userReportsSlice

